function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Tabs as GrommetTabs, Tab } from 'grommet';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { useHistory, useLocation, useRouteMatch, Switch, Route, Redirect, generatePath } from 'react-router-dom';
import useRouteChange from 'granite-admin/utils/useRouteChange';
import useQuery from 'granite-admin/utils/useQuery';
function Tabs({
  tabs,
  paramKey = 'sr_tabId',
  ...rest
}) {
  const {
    path
  } = useRouteMatch();
  const {
    pathname,
    search
  } = useLocation();
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: path
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: `${pathname}/${tabs[0].path}`,
      search: search
    }
  })), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/:${paramKey}`
  }, /*#__PURE__*/React.createElement(TabContent, _extends({
    tabs: tabs,
    paramKey: paramKey
  }, rest))));
}
const TabContent = ({
  tabs,
  theme,
  withBorder,
  fields,
  preserveQueryList,
  shouldFetchHelpTexts = true,
  shouldFetchPermissions = true,
  clearDataRouteChange = true,
  paramKey,
  boxProps,
  ...rest
}) => {
  // const { id } = useParams();
  // fields = useMemo(
  //   () => (fields?.length > 0 ? [...fields, 'docType', 'docSubType'] : ['docType', 'docSubType']),
  //   [fields],
  // );

  useRouteChange({
    fields,
    shouldFetchHelpTexts,
    shouldFetchPermissions,
    clearDataRouteChange
  });
  const {
    path,
    params: {
      [paramKey]: sr_tabId,
      ...restParams
    }
  } = useRouteMatch();
  const history = useHistory();
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    createQueryString,
    query
  } = useQuery();
  useEffect(() => {
    setActiveIndex(sr_tabId ? tabs.findIndex(tab => tab.path === sr_tabId) : 0);
  }, [sr_tabId, tabs]);
  const onActive = index => {
    const url = generatePath(path, {
      [paramKey]: tabs[index].path,
      ...restParams
    });
    history.push({
      pathname: url,
      search: createQueryString(query)
    });
  };
  const background = theme.tabs.background;
  return /*#__PURE__*/React.createElement(Box, _extends({
    background: background,
    flex: {
      grow: 1
    },
    round: "xsmall",
    pad: "small",
    elevation: "small",
    border: withBorder ? {
      color: 'brand',
      size: 'small',
      side: 'top'
    } : undefined
  }, boxProps), /*#__PURE__*/React.createElement(GrommetTabs, _extends({
    activeIndex: activeIndex,
    onActive: onActive
  }, rest), tabs.map(({
    title,
    path,
    ...rest
  }) => /*#__PURE__*/React.createElement(Tab, _extends({
    title: title,
    key: path
  }, rest)))), tabs[activeIndex]?.content);
};
TabContent.propTypes = {
  tabs: PropTypes.array,
  theme: PropTypes.object,
  withBorder: PropTypes.bool,
  fields: PropTypes.array,
  preserveQueryList: PropTypes.any,
  shouldFetchHelpTexts: PropTypes.bool,
  shouldFetchPermissions: PropTypes.bool,
  clearDataRouteChange: PropTypes.any,
  paramKey: PropTypes.any,
  boxProps: PropTypes.any
};
Tabs.propTypes = {
  tabs: PropTypes.array,
  withBorder: PropTypes.bool
};
Tabs.defaultProps = {
  tabs: [],
  withBorder: true,
  boxProps: {},
  preserveQueryList: []
};
export default withTheme(Tabs);